<template>
	<div class="acconut-form">
		<common-header style="background: #fff ;"></common-header>
		<div style="width: 1200px;margin:0 auto">
		<h3>legalXchain司法联盟链用户协议</h3>
		<div class='agreement-content'>
			    <p>发布日期：2023年10月17日<br/>生效日期：2023年10月17日</p>
				<br/>
				<p class="content-summarize">本协议是您（包括自然人、法人或其他组织，以下也称"服务使用人"）与真相网络科技（北京）有限公司（以下简称"真相科技"）之间关于legalXchain司法联盟链提供各项服务的协议。本协议中的"legalXchain司法联盟链"是指由真相科技运营的针对知识产权进行线上管理和保护的全环节、全维度的开放式系统平台，域名为www.legalxchain.com。</p>

				<p class="content-summarize">我们在此特别提醒，在使用legalXchain司法联盟链平台上提供的各项服务前，请您务必事先认真阅读本协议所有内容，协议中包括了免除或者限制legalXchain司法联盟链责任的免责条款及对用户的权利限制。请您审阅并表示接受或不接受所有服务条款，若您承诺接受则须遵守本协议约定；若您不接受则应立即停止注册程序或停止使用legalXchain司法联盟链提供的服务。若您有不明白或不理解之处，务必请向legalXchain司法联盟链客服垂询（电话：400-8650-010，微信：legalXchain司法联盟链kf），由客服人员向您作详细的说明和解释。</p>

				<p class="content-summarize">legalXchain司法联盟链有权根据需要不时地制订、修改本协议及各种规范、规则等，并在legalXchain司法联盟链平台上进行公告。变更后的协议和规范、规则一经公告，立即自动生效，您可以随时登录legalXchain司法联盟链平台查阅相关信息。如不同意该等变更，请用户在该等变更的公告刊载之日起72小时内以向人工客服（电话：400-8650-010，微信： legalXchain司法联盟链kf），收回授权，真相科技将在15个工作日内完成回复和处理。发送信息明确表明希望终止本协议（“注销申请”），legalXchain司法联盟链确认收到用户的邮件后将与用户协商本协议的终止以及终止后双方权利义务的履行。如用户在本条款所述时限内未发送申请，则本条款所述时限届满之时，视为用户已经同意接受该等变更，经修订的相关条款和规则一经公告，即于公告规定的特定生效日期自动生效并对用户产生法律约束力。</p>

				<h4>一、产品保护条款</h4>

				<p>1.1&nbsp;&nbsp;真相科技对legalXchain司法联盟链内所有非公有领域或非他方专有的信息内容享有知识产权（包括但不限于商标权、专利权、著作权），信息内容包括但不限于文字、图片、软件、音频、视频、数据、源代码、设计，非经真相科技书面授权同意，禁止复制、打印和传播属于legalXchain司法联盟链的信息内容用于其他用途。真相科技对legalXchain司法联盟链所有的产品、技术及程序享有知识产权，非经真相科技书面授权许可，禁止使用（包括但不限于以非法的方式打印、复制、传播、展示、下载等）。</p>

				<p>1.2&nbsp;&nbsp;您应正当使用legalXchain司法联盟链的各项服务，并承担一定的意外风险。在使用legalXchain司法联盟链服务过程中，您不得从事任何影响网络正常运作的行为，包括借助装置、软件或例行程序进行干预等。legalXchain司法联盟链在任何情况下不对因服务使用人不正当使用、有意或恶意利用服务的缺陷或其他特殊的、意外的原因（或行为）造成的非直接或间接的损失承担赔偿责任。</p>

				<p>1.3&nbsp;&nbsp;由于legalXchain司法联盟链的各项服务涉及互联网服务、本地操作环境、网络各环节等因素的影响，因此服务可能因计算机病毒或黑客攻击、网络提供商提供的服务差异化或出现意外状况、用户所在位置以及其他任何技术、互联网络、通信线路等原因出现异常或其他不能满足用户要求的风险。对非legalXchain司法联盟链造成的以上风险，legalXchain司法联盟链不承担任何责任。</p>

				<h4>二、定义及解释</h4>
				<p>2.1&nbsp;&nbsp;电子证据保全：真相科技按照法律证据认定要求提供存储环境和手段，对电子数据进行存储和保全的一种服务。</p>
				<p>2.2&nbsp;&nbsp;哈希值：应用密码学技术对数据加密后产生的密文。</p>
				<p>2.3&nbsp;&nbsp;北斗卫星授时服务：采用中国科学院国家授时中心的授时服务，以保证存取证的时间准确性。</p>
				<p>2.4&nbsp;&nbsp;GPS定位系统：是指利用卫星，在全球范围内实时进行定位、导航的系统，简称GPS(Global Positioning System)。</p>
				<p>2.5&nbsp;&nbsp;保全证书：本协议中指保全网签发的电子数据存证证明材料——电子保全证书，含有证书编号、区块链记录ID、SHA512摘要、所有者信息、保全时间、证书说明等内容。</p>
				<p>2.6&nbsp;&nbsp;legalXchain司法联盟链：真相科技设计、建设并由多个司法机构作为多节参与的司法联盟区块链。</p>
				<p>2.7&nbsp;&nbsp;第三方服务机构：指与真相科技合作为用户提供服务的第三方，如公证机构、第三方认证机构、司法鉴定中心、电子数据检验报告第三方机构、阿里云等。</p>
				<p>2.8&nbsp;&nbsp;第三方服务：指独立的专业服务商以第三方角色为legalXchain司法联盟链系统、真相取证用户提供的服务。</p>
				<p>2.9&nbsp;&nbsp;第三方用户：指通过委托legalXchain司法联盟链系统、真相取证注册用户或用户许可的某种方式使用legalXchain司法联盟链、真相取证服务的其他个人或机构。</p>

				<h4>三、服务内容</h4>
				<p>3.1&nbsp;&nbsp;电子数据区块链存证服务：为用户提供不限于电子数据文件、文件HASH、交易凭证、事务类、电子合同管理操作等电子数据存证服务，数据存储于legalXchain司法联盟链平台并应用区块链技术加密，哈希值存储于legalXchain司法联盟链。</p>
				<p>3.2&nbsp;&nbsp;证明服务：legalXchain司法联盟链根据您的请求为您在legalXchain司法联盟链平台存证的电子数据提供书面证明，包括但不限于legalXchain司法联盟链电子数据保全证书、CA数字证书。用户亦可通过legalXchain司法联盟链系统功能入口向司法机构申请证明材料，如公证书、司法鉴定意见书等。</p>
				<p>3.3&nbsp;&nbsp;查询服务：用户登录legalXchain司法联盟链账号，可查询用户信息、电子文件等。</p>
				<p>3.4&nbsp;&nbsp;技术支持：保全网提供用户以接口（API）形式接入使用的整体解决方案，并为用户系统的接入使用提供技术支持。</p>
				<p>3.5&nbsp;&nbsp;第三方举证服务：当用户存放在legalXchain司法联盟链系统的电子数据产生法律纠纷需要取证时，legalXchain司法联盟链将配合用户向司法机构提供本系统所存放的电子数据，说明电子数据的可靠性。</p>

				<h4>四、新用户注册</h4>

				<p>4.1&nbsp;&nbsp;您确认，在您进行legalXchain司法联盟链注册或实际使用legalXchain司法联盟链提供的服务时，您应当是具备完全民事权利能力和完全民事行为能力的自然人、法人或其他组织。若您不具备前述主体资格，legalXchain司法联盟链平台保留对您的账号采取冻结使用乃至注销您的账户等权利。</p>

				<p>4.2&nbsp;&nbsp;涉及无民事行为能力人、限制民事行为能力人使用legalXchain司法联盟链服务的情况，建议以其监护人的名义进行legalXchain司法联盟链注册并获取legalXchain司法联盟链提供的服务。</p>

				<p>4.3&nbsp;&nbsp;您在信息完善时所填写的身份信息不允许修改，除非您能提供充足的证据证明身份信息发生变更，但您无法以信息完善的信息对应的个体不存在为由，凭用户名及密码向legalXchain司法联盟链要求更改信息完善的信息。因此，信息完善时请务必使用您本人的真实信息，并确保信息完善时所需信息填写准确、完全，使用虚假信息进行信息完善，有可能会影响您后续使用legalXchain司法联盟链的其他功能、服务，甚至有可能损害您的权益。</p>

				<p>4.4&nbsp;&nbsp;信息完善是使用legalXchain司法联盟链许多功能，如版权交易、司法通道等功能的前提。建议您在注册后尽快进行信息完善，可获得legalXchain司法联盟链提供的更多服务项目。</p>

				<p>4.5&nbsp;&nbsp;您设置的用户名不应包含有非法的内容或其他可能侵犯他人合法权益、违背社会公序良俗的内容。一经发现，legalXchain司法联盟链有权对你的账户采取限制措施，并限期要求您进行修改，直至注销您的账户。</p>

				<p>4.6&nbsp;&nbsp;legalXchain司法联盟链发现、怀疑您登记的信息错误（包括有意或无意行为）、不实、过期或不完整的，legalXchain司法联盟链有权要求您限期作出说明、提供相关证明材料更正登记的信息，有权对您的账户采取限制措施，直至注销您的账户。legalXchain司法联盟链对此不承担任何责任，您将承担因此产生的任何直接或间接支出。</p>

				<p>4.7&nbsp;&nbsp;您必须认真阅读，在完全接受本协议的情况下，方可注册成legalXchain司法联盟链的用户。一旦注册成为我们的用户，即表示您同意接受协议各项条款的约束，包括接受legalXchain司法联盟链今后随时对服务条款所做的任何修改。届时您不应以未阅读本协议或不理解本协议的内容为由，主张协议无效，或要求撤销协议。</p>

				<p>4.8&nbsp;&nbsp;您在注册后，应牢记您的用户名及登录密码，妥善保管登录密码，采取积极地保密措施保护您（注册人）的上述信息及资料免受窃取及删除。用户名及登录密码将作为legalXchain司法联盟链确认您的身份的依据，您应对您的用户名和密码的安全，以及通过您的用户名和密码实施的行为负责。</p>

				<p>4.9&nbsp;&nbsp;legalXchain司法联盟链非经您本人（服务使用人）许可，不会将您的信息、相关数据、文件、作品泄露给他人。</p>

				<h4>五、legalXchain司法联盟链平台服务使用规范</h4>

				<p>5.1&nbsp;&nbsp;您必须合法的使用legalXchain司法联盟链的各项服务，保证在使用legalXchain司法联盟链的各项服务时所作陈述、记录等内容均真实、合法，您应当对通过您的账户所实施的一切行为负责。</p>

				<p>5.2&nbsp;&nbsp;您不得利用legalXchain司法联盟链的各项服务及产品从事非法活动，包括且不限于利用本站传播、存取非法、违反公序良俗的内容，不可采用网络、电脑技术等各种手段，制造虚假证据，并利用legalXchain司法联盟链存证，以获取个人利益、骗取保全证书。legalXchain司法联盟链在发现用户从事该等活动或发布该等内容时，有权不经用户同意而阻止该等活动并删除该等内容，同时有权不经通知而立即中止或终止用户对legalXchain司法联盟链的全部或部分功能的使用。</p>

				<p>5.3&nbsp;&nbsp;经发现或接到举报，或有合理理由怀疑您的账户存在违法情况及其他违反本协议的行为时，legalXchain司法联盟链有权对你的账户采取限制措施，并限期要求您向legalXchain司法联盟链公开可疑内容，限期进行整改，直至删除您的资料、应公安机关、司法机关的要求公开（公示）您的信息及违法内容、注销您的账户。legalXchain司法联盟链有权对您是否存在下述违法情况、违反本协议的行为单方作出认定，采取上述各项措施，无须征得您的同意或提前通知予您。</p>
				<p>&nbsp;&nbsp;（1）违反国家法律法规政策的任何内容（信息）；</p>
				<p>&nbsp;&nbsp;（2）违反国家规定的政治宣传和/或新闻信息；</p>
				<p>&nbsp;&nbsp;（3）涉及国家秘密和/或安全的信息；</p>
				<p>&nbsp;&nbsp;（4）封建迷信和/或淫秽、色情、下流的信息或教唆犯罪的信息；</p>
				<p>&nbsp;&nbsp;（5）博彩有奖、赌博游戏；违反国家民族和宗教政策的信息；</p>
				<p>&nbsp;&nbsp;（6）妨碍互联网运行安全的信息；</p>
				<p>&nbsp;&nbsp;（7）侵害他人合法权益的信息和/或其他有损于社会秩序、治安、公共道德的信息或内容。</p>
				<p>&nbsp;&nbsp;（8）您同时承诺不得为他人发布上述不符合国家规定和/或本服务协议约定的信息内容提供任何便利，包括但不限于设置URL、BANNER链接，发送邮件、短信等。</p>
				<p>5.4&nbsp;&nbsp;对于您的行为（包括非法的或正常使用legalXchain司法联盟链服务的行为）对任意第三方造成损害的，您均应当以自己的名义独立承担所有的法律责任，并应确保免于对legalXchain司法联盟链造成损失或增加费用。如legalXchain司法联盟链因您的行为（包括非法的或正常使用legalXchain司法联盟链服务的行为）遭受任何损失，或受到任何第三方的索赔，或受到任何行政管理部门的处罚，您应当赔偿legalXchain司法联盟链因此造成的损失及（或）发生的一切费用。</p>

				<p>5.5&nbsp;&nbsp;经发现或接到举报，或有合理理由怀疑您的账户存在违法情况及其他违反本协议的行为时，legalXchain司法联盟链有权对你的账户采取限制措施，并限期要求您向legalXchain司法联盟链公开可疑内容，限期进行整改，直至删除您的资料、应公安机关、司法机关的要求公开（公示）您的信息及违法内容、注销您的账户。legalXchain司法联盟链有权对您是否存在上述违法情况、违反本协议的行为单方作出认定，采取上述各项措施，无须征得您的同意或提前通知予您。 </p>

				<p>5.6&nbsp;&nbsp;您如果发现或怀疑您的账户被盗用，或存在其他安全问题时，您应当立即以有效方式通知legalXchain司法联盟链，并可以要求legalXchain司法联盟链采取一定的措施，且应配合legalXchain司法联盟链为采取措施而实施的调查、要求补证、身份核实等工作。若您所提供的资料未能使legalXchain司法联盟链完全确信您是账户的注册人时，legalXchain司法联盟链可能不会应您的要求采取措施。</p>

				<p>5.7&nbsp;&nbsp;legalXchain司法联盟链不对您的账户的安全问题承担任何责任。但您若冒用他人名义要求legalXchain司法联盟链对账户采取措施导致侵权、致他人损失的，您应承担一切责任。</p>

				<p>5.8&nbsp;&nbsp;因您填写、预留的联系方式有误，导致legalXchain司法联盟链无法与您取得联系的，因此产生的后果由您自行负责，包括您使用服务过程中产生任何损失或增加费用等。</p>

				<p>5.9&nbsp;&nbsp;legalXchain司法联盟链提供的各项服务均有一定的针对性，具体使用方式因服务内容不同而不尽相同。在使用前务必认真阅读各项服务的操作指南及须知，尤其是服务内容的限制，以免造成使用效果与您的设想存在过大的差距。涉及交叉使用legalXchain司法联盟链提供的各项服务的，应分别点击各服务项目进行。如有不清楚之处，务必联系客服人员，由客服人员对您进行指导。在使用legalXchain司法联盟链的各项功能服务之后，务必对相关的资料、结果进行浏览、查看、确认，以免发生意外，并有利于在发现意外，或因服务限制、错用服务等各项原因导致使用服务的效果不理想时及时采取补救措施。一旦发生意外，非legalXchain司法联盟链原因，收取的费用不予退还。在开始使用legalXchain司法联盟链服务后，收费即开始。收费与使用功能服务的效果无关，您不得以效果不好达不到目的等理由，向legalXchain司法联盟链提出退费要求。</p>

				<p>5.10&nbsp;&nbsp;涉及交叉使用legalXchain司法联盟链提供的各项服务的，应分别点击各服务项目进行。如有不清楚之处，务必联系客服人员，由客服人员对您进行指导。</p>

				<p>5.11&nbsp;&nbsp;用户同意，在一些情况下legalXchain司法联盟链有权利中止或终止用户对legalXchain司法联盟链的全部或部分功能的使用，这些情况包括但不限于根据本协议的约定、法律法规及法律文书的规定、有权机关的要求；legalXchain司法联盟链基于单方面合理判断认为账户操作存在异常或风险；用户遭到第三方投诉，且第三方已经提供了相关证据。发生上述情况造成中止或终止用户对legalXchain司法联盟链的全部或部分功能的使用的，legalXchain司法联盟链将及时通知用户。如账户中止的用户需要恢复服务，应按legalXchain司法联盟链通知的具体要求提交相关信息、资料、说明等文件，以便legalXchain司法联盟链进行核实，且legalXchain司法联盟链有权自行决定是否同意用户的申请。</p>

				<p>5.12&nbsp;&nbsp;用户认可，账户内的数据以legalXchain司法联盟链记录为准，如用户对该等数据存有异议的，应自用户账户数据发生变动之日起72小时内向本公司提出异议，并提供相关证据供legalXchain司法联盟链核实，否则视为用户认可该数据。</p>

				<p>5.13&nbsp;&nbsp;legalXchain司法联盟链提供的各项服务均为自助型服务，请勿向客服人员提出参与的要求。</p>

				<p>5.14&nbsp;&nbsp;为确保现场取证内容的效果，请您不要在嘈杂的环境中进行现场取证服务，并请现场无关人员回避。</p>

				<p>5.15&nbsp;&nbsp;确权、取证内容的真实性由您本人负责。legalXchain司法联盟链并不对您确权、取证内容的真实性进行审查，仅对您确权、取证的过程进行固定与证明。</p>

				<p>5.16&nbsp;&nbsp;非利用legalXchain司法联盟链取证手段或在legalXchain司法联盟链平台现场形成的证据资料，legalXchain司法联盟链并不证明其形成的环境和过程。</p>
				<p>5.17&nbsp;&nbsp;终止用户使用legalXchain司法联盟链全部功能即为账户终止，账户终止将导致账户被注销的结果，由此产生的一切后果由用户自行承担（包括但不限于清除账户内的数据、无法查询、无法为用户提供相关文件内容的证明）。</p>

				<h4>六、用户的变更</h4>
				<p>6.1&nbsp;&nbsp;legalXchain司法联盟链不对您的账户的安全问题承担任何责任。但您若冒用他人名义要求legalXchain司法联盟链对账户采取措施导致侵权、使用他人信息和文件注册使用legalXchain司法联盟链服务或向legalXchain司法联盟链提供的信息和资料不符合注册的相关规定，由此引起的一切责任和后果均由实际进行注册的人全部承担，legalXchain司法联盟链不因此承担任何法律责任，如因此而给legalXchain司法联盟链及其他用户造成任何损失，用户应当承担赔偿legalXchain司法联盟链及其他用户损失的责任。</p>
				<p>6.2&nbsp;&nbsp;因您填写、预留的联系方式有误，应当及时向legalXchain司法联盟链更新相应的信息和资料，如因用户未及时更新信息和资料导致legalXchain司法联盟链无法与您取得联系的、无法向用户提供服务或发生错误，因此产生的后果由您自行负责，包括您使用服务过程中产生任何损失或增加费用等，由此导致的全部法律责任和后果将由您独立承担。除非有法律规定或司法裁定，且征得legalXchain司法联盟链的同意，否则，legalXchain司法联盟链服务平台的用户名和密码不得以任何方式转让、赠与或继承（与账户相关的财产权益除外）。</p>

				<h4>七、用户的终止与注销</h4>
				<p>7.1&nbsp;&nbsp;出现以下情况时，legalXchain司法联盟链有权直接以注销用户的方式终止本协议：</p>
				<p>&nbsp;&nbsp;（1）您不是具备完全民事权利能力和完全民事行为能力的自然人、法人或其他组织；</p>
				<p>&nbsp;&nbsp;（2）您信息完善中的信息主要内容不真实、不准确、不及时、不完整，或注册信息包含非法的、可能侵犯他人合法权益的、违背社会公序良俗的内容，并经legalXchain司法联盟链提示后未在限期内进行修改的；</p>
				<p>&nbsp;&nbsp;（3）发现您利用legalXchain司法联盟链从事违法的、侵犯他人合法权益、违背社会公序良俗的行为，且经legalXchain司法联盟链提示后未在限期内改正的；</p>
				<p>&nbsp;&nbsp;（4）本协议（含规则）变更时，您明示并通知legalXchain司法联盟链不愿接受新的服务协议的；</p>
				<p>&nbsp;&nbsp;（5）其他legalXchain司法联盟链认为应当终止服务的情况。</p>
				<p>7.2&nbsp;&nbsp;您与legalXchain司法联盟链的协议关系终止后，您在使用legalXchain司法联盟链服务平台期间存在违法行为或违反本协议或规则的行为的，legalXchain司法联盟链仍可依据本协议向您要求承担法律责任。</p>
				
				<h4>八、不可抗力、免责及责任限制</h4>
				<p>8.1&nbsp;&nbsp;legalXchain司法联盟链仅承担本协议中明确约定的责任。</p>
				<p>8.2&nbsp;&nbsp;以legalXchain司法联盟链提供的服务为基础而形成的交易所产生的任何风险应由用户与交易对方承担，legalXchain司法联盟链对此不提供任何形式的担保。</p>
				<p>8.3&nbsp;&nbsp;账户的注册信息是由用户向legalXchain司法联盟链提交的，尽管legalXchain司法联盟链对开通和使用legalXchain司法联盟链服务的用户进行实名认证，但受限于目前实名认证手段的局限性和潜在漏洞，legalXchain司法联盟链无法保证该信息之准确、完整，因此用户应对自己的判断承担全部责任。</p>
				<p>8.4&nbsp;&nbsp;如用户选择使用legalXchain司法联盟链的合作单位所提供的产品或服务，该产品或服务的品质及内容由该合作单位自行负责。</p>
				<p>8.5&nbsp;&nbsp;用户充分知晓，legalXchain司法联盟链有权同时为用户及用户交易的相对方提供服务，用户同意对legalXchain司法联盟链可能存在的该等行为予以明确豁免，并不得以此来主张legalXchain司法联盟链在提供本服务时存在法律上的瑕疵。</p>
				<p>8.6&nbsp;&nbsp;为有效提供服务，legalXchain司法联盟链系统将不时进行维护和检测，因此产生的服务中断或不稳定状态，legalXchain司法联盟链不承担损害赔偿责任。</p>
				<p>8.7&nbsp;&nbsp;因国家相关主管部门颁布、变更的法令、政策导致legalXchain司法联盟链不能提供约定服务的，legalXchain司法联盟链不承担任何责任，但将根据相关的法令、政策变更、取消、增加legalXchain司法联盟链的服务内容和本协议。</p>
				<p>8.8&nbsp;&nbsp;因通信公司有线或无线通信系统、设备的检修、维护或不稳定，或黑客攻击，或电力部门技术调整或故障，或银行方面的问题等原因，导致legalXchain司法联盟链服务中断或不稳定，legalXchain司法联盟链不承担损害赔偿责任，但legalXchain司法联盟链将在2小时内反应，并尽商业上的最大努力争取尽快恢复正常服务。</p>
				<p>8.9&nbsp;&nbsp;因台风、地震、海啸、洪水、停电、战争、恐怖袭击等不可抗力之因素，造成legalXchain司法联盟链无法提供服务的，legalXchain司法联盟链不承担任何责任。</p>
				<p>8.10&nbsp;&nbsp;因提供legalXchain司法联盟链服务所使用的网络、系统、其他软件本身的固有缺陷、运行错误而给用户造成的任何直接或间接损失（包括但不限于数据丢失、利润损失、丧失商业机会等），legalXchain司法联盟链不承担赔偿责任。</p>
				<p>8.11&nbsp;&nbsp;legalXchain司法联盟链对甲方因其账号、密码、需要认证的文件等遗失、被盗、被误用或被擅自修改、计算机设备故障、操作失误等情况造成的损失不负责任，但由于legalXchain司法联盟链原因造成的除外。</p>
				<p>8.12&nbsp;&nbsp;legalXchain司法联盟链提供的各项服务均经过严格的内部功能测试，因用户使用的场景不同，易受网络环境等客观条件的影响，不能保证用户在使用服务时不遇到异常情况，如您在使用过程中遇到异常情况，请重新操作，或者联系客服进行申诉。</p>
				<h4>九、违约责任</h4>
				<p>9.1&nbsp;&nbsp;本协议的订立、变更、执行和解释，以及与本协议有关的争议解决，均应适用中华人民共和国法律。如与本协议有关的某一特定事项没有法律规定或规定不明确，则应参照通用的国际商业惯例和行业惯例。</p>
				<p>9.2&nbsp;&nbsp;如因本协议或legalXchain司法联盟链服务所引起或与其有关的任何争议应向legalXchain司法联盟链所在地人民法院起诉。</p>
				<p>9.3&nbsp;&nbsp;除本协议另有规定外，在任何情况下，legalXchain司法联盟链对本协议所承担的违约赔偿责任总额不超过向用户收取的当次服务费用总额。</p>
				<p>9.4&nbsp;&nbsp;因用户违反本协议约定或因违法、违规、违背社会善良风俗及用户侵权行为给国家利益、社会利益、第三方利益及legalXchain司法联盟链造成损失的，由用户承担全部责任；如legalXchain司法联盟链先行赔偿的，legalXchain司法联盟链有权向乙方追偿。legalXchain司法联盟链亦有权要求客户承担legalXchain司法联盟链因上述行为所遭受的全部直接损失、</p>
				<h4>十、其他</h4>
				<p>10.1&nbsp;&nbsp;本协议自用户同意勾选并成功注册为legalXchain司法联盟链用户之日起生效，除非legalXchain司法联盟链终止本协议或者用户注销账户，否则本协议始终有效。本协议终止并不免除用户根据本协议或其他有关协议、规则已经产生的义务和责任。</p>
				<p>10.2&nbsp;&nbsp;用户利用legalXchain司法联盟链或真legalXchain司法联盟链服务从事任何不符合中国法律法规、违反本协议或legalXchain司法联盟链其他规则、侵犯他人权益的活动，使第三方向legalXchain司法联盟链及其代理人提出赔偿请求（包括司法费用和其他专业人士的费用），如legalXchain司法联盟链及其代理人承担了赔偿责任即获得了向该用户追偿的权利，该用户应承担全部赔偿费用以使legalXchain司法联盟链及其代理人免遭损失。</p>
				<p>10.3&nbsp;&nbsp;本协议中的任何条款完全或部分无效或不具有执行力，不影响本协议的其余条款的效力。</p>
				<p>10.4&nbsp;&nbsp;本协议的标题仅为方便而设，在解释本协议时应被忽略。</p>
		</div>
	</div>
	</div>
</template>

<script>

export default {
	name:'UserAgreement',
	components:{},
	data () {
		return {
		}
	}
}	
</script>

<style scoped>
.acconut-form{
	position: relative;
}
.acconut-form h3{
	position: absolute;
	left:50%;
	transform: translate(-50%);
	font-weight: 700;
	font-size: 22px;
	top:100px;
}
.agreement-content{
	margin: 80px 31px 60px;
	padding: 40px 45px;
	border:1px solid #e8e8e8;
}
.agreement-content p{
  font-size: 14px;
  line-height: 2.14;
  letter-spacing: 0.3px;
  color: #3a3a3a;
}
.agreement-content p.content-summarize{
	text-indent: 2em;
}
.agreement-content h4{
	color: #333;
	margin-top: 25px;
	margin-bottom: 10px;
}
</style>